module.exports = __webpack_public_path__ + "static/img/backtop.cbc63def.svg";